export * from "Search/Scenarios/Shared/Components/ZeroData/index";
